import { render, staticRenderFns } from "./gzhRecommended.vue?vue&type=template&id=58d2fe9a&scoped=true&"
import script from "./gzhRecommended.vue?vue&type=script&lang=js&"
export * from "./gzhRecommended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2fe9a",
  null
  
)

export default component.exports